<ng-template #addRefPolicy let-c="close" let-d="dismiss">
  <div class="modal-header d-flex flex-row justify-content-between">
    @if (action === 'add-client-ref' && client) {
      <h2 class="text-center">{{ 'ref-policies-add-client-title-client' | translate }} {{ client.name }}</h2>
    } @else if (action === 'add-client-ref' && !client) {
      <h2 class="text-center">{{ 'ref-policies-add-client-title' | translate }}</h2>
    } @else {
      <h2 class="text-center">{{ 'ref-policies-add-default-title' | translate }}</h2>
    }
    <button type="button" class="modal-close" aria-label="Close" (click)="c('Cross click')"></button>
  </div>
  <div class="modal-body add-modal">
    <div class="d-flex flex-column align-items-center">
      <table>
        <tr>
          @if (!formDisabled()) {
            <td>
              <input class="form-control" [placeholder]="'ref-policies-name' | translate"
                [formControl]="getFormControl('name')">
            </td>
          } @else {
            <td>
              <input class="form-control" [placeholder]="'ref-policies-name' | translate" disabled>
            </td>
          }
        </tr>
        @if (action === 'add-client-ref' && !client && lClient.length != 0) {
          <tr class="client">
            <td class="title">
              <h4>{{ 'setting-nav-clients' | translate }}</h4>
            </td>
            <td>
              <div class="d-flex flex-column justify-content-center align-items-center block">
                <div class="d-flex align-items-center justify-content-center block">
                  <div ngbDropdown class="d-inline-block">
                    <button type="button" class="btn" id="client" ngbDropdownToggle>
                      {{ findClient()?.name }}
                    </button>
                    <div class="d-flex justify-content-center block">
                      <div ngbDropdownMenu aria-labelledby="application">
                        @for (client of lClient; track client.id) {
                          <button ngbDropdownItem (click)="setClient(client.id)">
                            {{ client.name }}
                          </button>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        }
      </table>
      @if (form) {
        @if (getFormControl('name').invalid && getFormControl('name').dirty) {
          <div class="alert alert-danger">
            @if (getFormControl('name').errors?.['required']) {
              <div>{{ 'setting-form-error-required' | translate }}</div>
            }
            @if (getFormControl('name').errors?.['whitespace'] && !getFormControl('name').errors?.['required']) {
              <div>{{ 'setting-form-error-invalid-value' | translate }}</div>
            }
          </div>
        }
      } @else {
        <app-loading-error [boolean]="false"
          [search]="'ref-policies-form-error-no-client' | translate"
          [order]="'ref-policies-form-error-client-order' | translate"></app-loading-error>
      }
      <button type="button" class="btn btn-outline-success" [disabled]="formDisabled() || form?.invalid"
        (click)="emitAddRefPolicy();c('Save changes')">{{ 'confirm' | translate }}</button>
    </div>
  </div>
</ng-template>

<ng-template #editRefPolicy let-c="close" let-d="dismiss">
  <div class="modal-header d-flex flex-row justify-content-between">
    @if (action === 'edit-client-ref') {
      <h2 class="text-center">{{ 'ref-policies-edit-client-title' | translate }}</h2>
    } @else {
      <h2 class="text-center">{{ 'ref-policies-edit-default-title' | translate }}</h2>
    }
    <button type="button" class="modal-close" aria-label="Close" (click)="c('Cross click')"></button>
  </div>
  <div class="modal-body edit-modal">
    <div class="d-flex flex-column align-items-center">
      <table>
        <tr>
          @if (!formDisabled()) {
            <td>
              <input class="form-control" [placeholder]="'ref-policies-name' | translate"
                [formControl]="getFormControl('name')">
            </td>
          } @else {
            <td>
              <input class="form-control" [placeholder]="'ref-policies-name' | translate" disabled>
            </td>
          }
        </tr>
      </table>
      @if (form) {
        @if (getFormControl('name').invalid && getFormControl('name').dirty) {
          <div class="alert alert-danger">
            @if (getFormControl('name').errors?.['required']) {
              <div>{{ 'setting-form-error-required' | translate }}</div>
            }
            @if (getFormControl('name').errors?.['whitespace'] && !getFormControl('name').errors?.['required']) {
              <div>{{ 'setting-form-error-invalid-value' | translate }}</div>
            }
          </div>
        }
      } @else {
        <app-loading-error [boolean]="false"
          [search]="'ref-policies-form-error-no-client' | translate"
          [order]="'ref-policies-form-error-client-order' | translate"></app-loading-error>
      }
      <div class="d-flex flex-row justify-content-around buttons">
        <button type="button" class="btn btn-outline-primary"
          (click)="c('Cross click')">{{ 'cancel' | translate }}</button>
        <button type="button" class="btn btn-outline-success"
          (click)="emitPatchRefPolicy();c('Save changes')">{{ 'confirm' | translate }}</button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #deleteRefPolicy let-c="close" let-d="dismiss">
  <div class="modal-body delete-modal">
    <div class="d-flex flex-column align-items-center">
      <h2>{{ 'ref-policies-delete-title' | translate }}</h2>
      <div class="d-flex flex-row justify-content-between align-items-center elem">
        <h3 class="name">{{ refPolicy?.name }}</h3>
        @if (refPolicy?.client) {
          <div class="d-flex flex-row justify-content-around align-items-center">
            <img id="clients" src="assets/icons/person.dark.svg">
            <h3 class="value">{{ refPolicy?.client?.name }}</h3>
          </div>
        }
      </div>
      <div class="d-flex flex-row justify-content-around">
        <button type="button" class="btn btn-outline-primary"
          (click)="c('Cross click')">{{ 'cancel' | translate }}</button>
        <button type="button" class="btn btn-outline-success"
          (click)="emitDeleteRefPolicy();c('Save changes')">{{ 'confirm' | translate }}</button>
      </div>
    </div>
  </div>
</ng-template>

@if (action === 'add-client-ref' || action === 'add-default-ref') {
  <div class="addrefpolicy d-flex flex-row justify-content-center align-items-center" type="button"
    (click)="open({ content: addRefPolicy })">
    <img src="assets/icons/Policies/add.svg">
  </div>
}
@if (action === 'delete') {
  <img type="button" (click)="open({ content: deleteRefPolicy })" class="delete"
    src="assets/icons/Policies/cross.svg">
}
@if (action === 'edit-client-ref' || action === 'edit-default-ref') {
  <img type="button" (click)="open({ content: editRefPolicy })" class="edit"
    src="assets/icons/Policies/edit.svg">
}


